//
//
//
//
//
//
//
//

import { mapState, mapGetters } from 'vuex';

import authMixin from '@motionelements/core/src/components/mixins/auth.mixin.js';

export default {
  name: 'ContributorSignUpLink',
  components: {
    NuxtClientOnly: () => import('@motionelements/core/src/components/nav/NuxtClientOnly.vue'),
  },
  mixins: [authMixin],
  computed: {
    ...mapState({
      isLoggedIn: state => state.user.isLoggedIn,
      isContributor: state => state.user.isArtist,
    }),
    ...mapGetters({
      isContributorInvited: 'user/isContributorInvited',
    }),
  },
  methods: {
    becomeContributorLink() {
      if (!this.isLoggedIn) {
        this.goToLogin(['goal=artist_signup']);
      } else if (this.isContributor) {
        window.location.href = this.$link('/signup/artist-welcome').url();
      } else if (this.isContributorInvited) {
        window.location.href = this.$link('/signup/artist-steps').url();
      } else {
        const locale = ['en', 'ja', 'ko'].includes(this.$i18n.locale) ? this.$i18n.locale : 'en';
        window.location.href = `https://form.motionelements.com/${locale}/forms/049ce330-b01e-4b5b-b23a-8cebb0f296ef`;
      }
    },
  },
};
